import { FC } from "react";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";

export const NEW_PROVIDER_REPORT_PAST_RUN_MESSAGE =
  "You're viewing a past project run. Return to the trend chart and select the most recent published project run to generate a report.";

const NewProviderReportPastRunNotice: FC = () => {
  return (
    <div
      className="d-flex align-items-center bg-white border rounded-bottom p-3 text-info"
      data-testid="new-provider-report__past-run-notice"
      role="note"
    >
      <QesIcon
        iconName={QesIcons.InfoCircle}
        description="Information"
        className="flex-shrink-0 me-2"
        width="20"
      />
      <span>{NEW_PROVIDER_REPORT_PAST_RUN_MESSAGE}</span>
    </div>
  );
};

export default NewProviderReportPastRunNotice;
